<template>
  <Print v-if="isPrint" :board="board" :form="form" />
  <div v-else>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!-- TBM 정보 -->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> TBM 정보</h5>
      </vs-col>
    </vs-row>
    <div class="writeGridContainer mt-4">
      <div>
        <div>TBM 실시일</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_1 }}</p>
        <date-selector v-else :readonly="board.readonly" v-model="form.inputB_1" />
      </div>
      <div>
        <div>TBM 실시시간</div>
        <div v-if="!isPrint" class="flex-1 flex items-center">
          <time-selector v-model="form.inputB_2" />
          <p class="px-2">~</p>
          <time-selector v-model="form.inputB_3" />
        </div>
        <span v-else class="print-input">{{ `${form.inputB_2} ~ ${form.inputB_3}` }}</span>
      </div>
      <div>
        <div>작업명</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_4 }}</p>
        <ml-input v-else v-model="form.inputB_4" :readonly="board.readonly" />
      </div>
      <div>
        <div>작업내용</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_5 }}</p>
        <ml-input v-else v-model="form.inputB_5" :readonly="board.readonly" />
      </div>
      <div>
        <div>TBM 장소</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_6 }}</p>
        <ml-input v-else v-model="form.inputB_6" :readonly="board.readonly" />
      </div>
      <div>
        <div>위험성평가 실시여부</div>
        <div>
          <vs-radio class="mr-4" v-model="form.inputB_7" vs-value="예" color="secondary" :disabled="board.readonly">예</vs-radio>
          <vs-radio v-model="form.inputB_7" vs-value="아니오" color="secondary" :disabled="board.readonly">아니오</vs-radio>
        </div>
      </div>
    </div>

    <!--    잠재위험요인-->
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="잠재위험요인"
      :tableData="[
        { id: 'no', title: '연번', type: 'no', width: '80px' },
        {
          id: 'input1',
          title: '잠재위험요인',
          type: 'text',
          placeholder: '입력필드',
        },
        {
          id: 'input2',
          title: '대책 (※ 제거 → 대체 → 통제 순서 고려)',
          type: 'text',
          placeholder: '입력필드',
        },
      ]"
      v-model="form.risk_factors"
    />

    <!-- 중점위험요인 -->
    <div>
      <vs-row class="mt-6">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 중점위험요인</h5>
        </vs-col>
      </vs-row>
      <div class="writeGridContainer mt-6">
        <div class="writeGridLineItem">
          <div>선정</div>
          <p v-if="isPrint" class="print-input">{{ form.inputD_1 }}</p>
          <ml-input v-else v-model="form.inputD_1" :readonly="board.readonly" />
        </div>
        <div class="writeGridLineItem">
          <div>대책</div>
          <p v-if="isPrint" class="print-input">{{ form.inputD_2 }}</p>
          <ml-input v-else v-model="form.inputD_2" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!-- TBM 리더 확인 -->
    <div>
      <vs-row class="mt-6">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> TBM 리더 확인</h5>
        </vs-col>
      </vs-row>
      <div class="writeGridContainer mt-4">
        <div>
          <div>소속명</div>
          <p v-if="isPrint" class="print-input">{{ form.inputE_1 }}</p>
          <ml-input v-else v-model="form.inputE_1" :readonly="board.readonly" />
        </div>
        <div>
          <div>직책</div>
          <p v-if="isPrint" class="print-input">{{ form.inputE_2 }}</p>
          <ml-input v-else v-model="form.inputE_2" :readonly="board.readonly" />
        </div>
        <div>
          <div>성명</div>
          <p v-if="isPrint" class="print-input">{{ form.inputE_3 }}</p>
          <ml-input v-else v-model="form.inputE_3" :readonly="board.readonly" />
        </div>
        <div>
          <div>서명</div>
          <p v-if="isPrint" class="print-input">{{ form.inputE_4 }}</p>
          <sign-field v-else v-model="form.inputE_4" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!-- 작업 전 안전조치 확인 ※위 잠재위험요인(중점위험 포함) 안전조치 여부 재확인 -->
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="작업 전 안전조치 확인 ※위 잠재위험요인(중점위험 포함) 안전조치 여부 재확인"
      :tableData="[
        { id: 'no', title: '연번', type: 'no', width: '80px' },
        {
          id: 'input1',
          title: '잠재위험요소(중점위험 포함)',
          type: 'text',
          placeholder: '입력필드',
        },
        {
          id: 'input2',
          title: '조치여부',
          type: 'radio',
          middle: true,
          radioItems: [{ value: '예' }, { value: '아니오' }],
        },
        {
          id: 'input3',
          title: '‘아니오’인 경우 조치 내용',
          type: 'customType',
          placeholder: '입력필드',
        },
      ]"
      v-model="form.safety_measures"
    >
      <template #customType="{ trData, value, input }">
        <input v-if="!!trData && !!trData.input2 && trData.input2 === '아니오'" :readonly="board.readonly" class="w-full flex-1" :value="value" @input="(e) => input(e.target.value)" />
      </template>
    </table-custom>

    <div class="writeGridContainer mt-4">
      <div class="writeGridLineItem">
        <div class="textarea-label">작업 전 일일 안전점검 시행 결과</div>
        <p v-if="isPrint" class="print-input">{{ form.inputF_1 }}</p>
        <ml-textarea v-else v-model="form.inputF_1" :readonly="board.readonly" placeholder="※위험요인 중 조치가 되지 않은 사항, 작업자의 TBM 내용 숙지 여부 중점체크" rows="4" class="mb-0"/>
      </div>
      <div class="writeGridLineItem">
        <div class="textarea-label">작업 후 종료 미팅 (중점대책의 실효성)</div>
        <p v-if="isPrint" class="print-input">{{ form.inputF_2 }}</p>
        <ml-textarea v-else v-model="form.inputF_2" :readonly="board.readonly" rows="4" class="mb-0"/>
      </div>
    </div>

    <!--    참석자 명단 ※TBM에 참여하지 않은 작업자를 확인하여 미팅 참석 유도-->
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="참석자 명단 ※TBM에 참여하지 않은 작업자를 확인하여 미팅 참석 유도"
      :tableData="[
        {
          id: 'input1',
          title: '소속명',
          type: 'text',
        },
        {
          id: 'input2',
          title: '직종',
          type: 'text',
        },
        {
          id: 'input3',
          title: '이름',
          type: 'text',
        },
        {
          id: 'input4',
          title: '서명',
          type: 'sign',
        },
        {
          id: 'input5',
          title: '비고',
          type: 'text',
        },
      ]"
      v-model="form.participant"
    />

    <!--    사진대지-->
    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList" :is-print="isPrint" :readonly="board.readonly" section-title="사진대지" placeholder="신축현장 점검" />

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import DateSelector from "@/components/selector/DateSelector.vue";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import TableCustom from "@/components/TableCustom.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import Print from "./Print.vue";
import SignField from "@/components/SignField";

export default {
  components: {
    PhotoUploadGridModule,
    TableCustom,
    TimeSelector,
    DateSelector,
    FieldSelectModule,
    FileUploadModule,
    Print,
    SignField,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
        inputB_6: "",
        inputB_7: "",

        inputD_1: "",
        inputD_2: "",

        inputE_1: "",
        inputE_2: "",
        inputE_3: "",
        inputE_4: "",

        inputF_1: "",
        inputF_2: "",

        risk_factors: [],
        safety_measures: [],
        participant: [],

        stdInfo: {},
        fileList: [],
        photoList: [],
      },
    };
  },
  methods: {},
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

input {
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  padding: 0.7rem !important;
  transition: all 0.3s ease;
  &:focus {
    border: 1px solid rgba(var(--vs-primary), 1) !important;
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
  }
}
</style>
